import Dropdown from '../ui/Dropdown';
import Collection from '../ui/Collection';

function Attribute(props) {
	if(props.attrStyle === 2) {
		return (
			<Dropdown {...props}/>
		);
	}
	return (
		<Collection {...props}/>
	);
}

export default Attribute;
/*
*/